import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchDataType } from '@actions/data-types-actions';
import SettingsForm from '@components/settings/settings-form';
import { getNotificationsSettingsConfig } from '@constants/config';

const Notifications = () => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.settings.notifications);

  const layout = getNotificationsSettingsConfig();

  const getPayload = useCallback(formData => ({
    notifications: formData
  }), []);

  // Reload notifications after saving notification settings:
  const postSave = useCallback(() => {
    dispatch(fetchDataType('notification'));
  }, [dispatch]);

  return (
    <SettingsForm
      data={data}
      layout={layout}
      getPayload={getPayload}
      postSave={postSave}
    />
  );
};

export default Notifications;
